<template>
  <div 
    class="header_table center_block"
    :style="`width: ${width} !important`"
  >
    <div
      class="pointer"
      @click="openMenu"
    >
      {{ name }}
     
    </div>

    <div
      v-if="state.openWindow == this.field"
      class="card block_filter"
      style="width: max-content; max-width: 500px;"
    >
      <div class="f14 card-header">
        <label class="f14">Filtro</label>
      </div>
      <div class="card-body pt-1">
        <div v-for="(agg) in aggs.buckets" :key="agg['key']">
          <label :for="agg['key']"></label>
          <input
            type="checkbox"
            :id="agg['key']"
            :value="agg['key']"
            v-model="filter_data"
          />
            ({{agg['doc_count']}}) {{ agg['key'] }}
          </label>
        </div>
        <input
          v-on:keyup.enter="filter"
          v-model="search_text"
          type="text"
          class="form-control"
        />
        <!-- <button
          @click="filter"
          class="btn btn-small mt-1 btn-success left"
        >
          Salvar
        </button> -->
        <button
          @click="removefilter"
          class="btn btn-small mt-1 btn-danger right"
        >
          Limpar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { state, gettersMap, mutationsMap } from "store/table.js";

export default {
  props: ["name", "entity", "field", "width", "aggs"],
  components: {  },
  data: () => ({
    open: false,
    state: state,
    search_text: "",
    filter_data: [],
  }),
  mounted() {
    
  },
  methods: {
    openMenu() {
      if (gettersMap.getOpenWindow() == this.field) {
        mutationsMap.setOpenWindow("");
        return;
      }
      mutationsMap.setOpenWindow(this.field);
    },
    filter() {
      let filter_field = {};
      filter_field[this.field] = this.search_text;
      mutationsMap.setWhere(filter_field);
      mutationsMap.setOpenWindow("");
    },
    removefilter() {
      mutationsMap.removeFilter(this.field);
      this.search_text = "";
      mutationsMap.setOpenWindow("");
      this.filter();
    },
  },
  watch: {
    filter_data() {
      let filter_field = {};
      let where = gettersMap.getWhere();
      if(Object.keys(where).length > 0) {
        const keys = Object.keys(where);
        keys.forEach((key) => {
          filter_field[key] = where[key];
        })
      }
      filter_field[this.field] = this.filter_data;
      mutationsMap.setWhere(filter_field);
    }
  },
};
</script>